import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'category-tabs',
  name: '分类菜单',
  icon: '类',
  group: '导航组件',
  description: '展示可切换的横向分类',
  defaultProps: {
    items: [],
    activeIndex: 0,
    sticky: false
  }
}
